import {
  AccountItem,
  CommonEventsTypes,
} from '@pango-inc/keybox-sdk-wrapper/dist/sdk-wrapper.main';
import { DocumentItem } from '@pango-inc/vault.wasm/dist/vault/vault.types';
import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { VaultState } from './types';
import { DEFAULT_SETTINGS } from './const';

// Initial State
const initialState: VaultState = {
  accounts: {
    list: [],
    isLoading: true,
    requestCompleted: false,
  },
  accountLimits: [],
  familyMembers: [],
  info: {
    data: {
      isAuthorized: false,
      isLocked: true,
    },
    isLoading: true,
  },
  settings: {
    ...DEFAULT_SETTINGS,
  },
  connectionStatus: 'success',
  pwmStorage: null,
  isLoading: true,
  accountForm: {
    show: false,
    submitting: false,
  },
  accountDelete: {
    show: false,
  },
  unlockModalState: {
    show: false,
  },
  extensionInstallModalState: {
    show: false,
  },
  emailAliasModalState: {
    show: false,
  },
  createItemModalState: {
    show: false,
  },
  createItemCompleteFlowModalState: {
    show: false,
  },
  passwordTypeSelectModalState: {
    show: false,
  },
  darkWebMonitoringModalState: {
    show: false,
  },
  securityInfoModalState: {
    show: false,
  },
  darkWebScanningModalState: {
    show: false,
  },
  onboardingExtension: {
    step: '',
  },
  scrollTo: null,
  accountPasswordHistoryModalState: {
    show: false,
  },
  accountAddPasswordOneTimePasswordModalState: {
    show: false,
  },
  accountRemovePasswordOneTimePasswordModalState: {
    show: false,
  },
  accountPasswordSharedModalState: {
    show: false,
  },
  accountOnboardingTooltipState: {
    type: null,
    id: null,
  },
  accountPasswordSettingsModalState: {
    show: false,
    state: '', // VAULT_SETTINGS_STATE.INITIAL,
  },
  changePasswordFlowState: {
    show: false,
  },
  unlockState: {
    error: '',
    submitting: false,
  },
  foundAccount: null,
  emails: [],
  vaultCriticalAlerts: {
    list: [],
    isLoading: true,
  },
  migrationModalState: {
    show: false,
    documentType: null,
    step: 'initial',
    monitoredItem: null,
    cyclical: false,
  },
  isVaultExists: false,
  documents: [],
  showPasswordDefenseInstallcard: true,
};

const vaultSlice = createAppSlice({
  name: 'vault',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setVaultAccounts: (state, action: PayloadAction<AccountItem[]>) => {
      state.accounts.list = action.payload;
    },
    setAppInfo: (state, action: PayloadAction<CommonEventsTypes.AppInfo>) => {
      state.info.data = { ...state.info.data, ...action.payload };
    },
    setVaultExists: (state, action: PayloadAction<boolean>) => {
      state.isVaultExists = action.payload;
    },
    setImportedVaultAccounts: (state, action: PayloadAction<AccountItem[]>) => {
      state.accounts.list = { ...state.accounts.list, ...action.payload };
    },
    setVaultDocuments: (state, action: PayloadAction<DocumentItem[]>) => {
      state.documents = action.payload;
    },
    setShowPasswordDefenseInstallcard: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.showPasswordDefenseInstallcard = action.payload;
    },
    resetVaultInfo: () => initialState,
  },
});

export const {
  setIsLoading,
  setVaultAccounts,
  setAppInfo,
  resetVaultInfo,
  setVaultExists,
  setVaultDocuments,
  setShowPasswordDefenseInstallcard,
} = vaultSlice.actions;

export default vaultSlice.reducer;
